<template>
  <br>
  <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
    <h4 style="margin: 0;">Renovación de Suscripción: Proceso Completo</h4>
    <h4 style="margin: 0;">
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">4</span>
    </h4>
  </div>
  <hr>
  <div class="progress">
    <div class="progress-bar" role="progressbar" aria-label="Progress Complete" style="width: 100%" aria-valuenow="100"
      aria-valuemin="0" aria-valuemax="100"></div>
  </div>
  <br>
  <br>

  <div style="text-align: center;">
    <h5>
      ¡Tu suscripción ha sido renovada satisfactoriamente!
      <br><br>
      Se ha enviado un correo de confirmación a la dirección proporcionada.
    </h5>
    <br><br>
    <button type="button" class="btn btn-primary btn-lg" style="padding-left: 2.5rem; padding-right: 2.5rem;"
      @click="iniciarSesion()">Volver al Inicio</button>
  </div>
</template>

  <script>
  export default {
    data() {
      return {
        usuario: {},
        mensaje: '',
        mensaje02: ''
      }
    },
    methods: {
      async iniciarSesion() {
          this.$router.push('Login')
      },
    },
  }
  </script>
  <style>
  .divider:after,
  .divider:before {
    content: "";
    flex: 1;
    height: 1px;
    background: #eee;
  }
  
  .h-custom {
    height: calc(100% - 73px);
  }
  
  @media (max-width: 450px) {
    .h-custom {
      height: 100%;
    }
  }
  
  .mensaje {
    color: red;
    font-family: verdana;
    font-size: 12px;
    width: 100%;
  }
  </style>